import React, {useEffect, useState} from "react";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, TextField, Typography
} from "@mui/material";
import {LoadingButton} from "@mui/lab";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import attendanceServices from "app/services/attendance-services";
import {DIAS} from "./attendanceFormat";

// El horario semanal: varios tramos por dia (universidad, almuerzo). Se guarda como un horario
// nuevo que rige desde una fecha, asi cambiarlo no reescribe como se midieron los meses pasados.
const ScheduleDialog = ({open, onClose, onSaved, userId, schedule}) => {
    const [blocks, setBlocks] = useState({});
    const [validFrom, setValidFrom] = useState("");
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (!open) return;
        setBlocks(JSON.parse(JSON.stringify(schedule?.blocks || {})));
        setValidFrom(moment().format("YYYY-MM-DD"));
    }, [open, schedule]);

    const tramos = (day) => blocks[day] || [];
    const setTramos = (day, lista) => setBlocks((b) => ({...b, [day]: lista}));

    const cambiar = (day, i, j) => (e) => {
        const lista = tramos(day).map((t) => [...t]);
        lista[i][j] = e.target.value;
        setTramos(day, lista);
    };

    const guardar = async () => {
        try {
            setSaving(true);
            await attendanceServices.saveSchedule({user_id: userId, valid_from: validFrom, blocks});
            onSaved();
        } catch (_error) {
            // El interceptor global muestra el motivo.
        } finally {
            setSaving(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Horario semanal</DialogTitle>
            <DialogContent>
                <Stack spacing={2} sx={{pt: 1}}>
                    <TextField type="date" label="Rige desde" value={validFrom} sx={{maxWidth: 220}}
                               onChange={(e) => setValidFrom(e.target.value)} InputLabelProps={{shrink: true}}
                               helperText={schedule?.valid_from ? `El actual rige desde el ${schedule.valid_from}` : "Todavía no hay horario"}/>
                    {[1, 2, 3, 4, 5, 6, 7].map((day) => (
                        <Stack key={day} direction={{xs: "column", sm: "row"}} spacing={1}
                               alignItems={{sm: "center"}}>
                            <Typography sx={{width: 100, flexShrink: 0, fontWeight: 600}}>{DIAS[day]}</Typography>
                            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap alignItems="center">
                                {tramos(day).map(([inicio, fin], i) => (
                                    <Stack key={i} direction="row" spacing={0.5} alignItems="center">
                                        <TextField type="time" size="small" value={inicio} onChange={cambiar(day, i, 0)}
                                                   sx={{width: 120}}/>
                                        <span>–</span>
                                        <TextField type="time" size="small" value={fin} onChange={cambiar(day, i, 1)}
                                                   sx={{width: 120}}/>
                                        <IconButton size="small" aria-label="Quitar tramo"
                                                    onClick={() => setTramos(day, tramos(day).filter((_, k) => k !== i))}>
                                            <CloseIcon fontSize="small"/>
                                        </IconButton>
                                    </Stack>
                                ))}
                                <Button size="small" startIcon={<AddIcon/>}
                                        onClick={() => setTramos(day, [...tramos(day), ["", ""]])}>
                                    Tramo
                                </Button>
                            </Stack>
                        </Stack>
                    ))}
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <LoadingButton variant="contained" loading={saving} disabled={!validFrom} onClick={guardar}>
                    Guardar horario
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};

export default ScheduleDialog;
